import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactToolTip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import BrandingContext from '../../Context/BrandingContext';

export default function ToggleSwitch(props) {
  const { checked, children, disabled, geofencesLoading, onChange } = props;
  const restrictedTooltip = useMemo(
    () =>
      disabled && children === 'Suborg Assets'
        ? { 'data-tip': 'This action is restricted based on your access level' }
        : {},
    [children, disabled]
  );
  const { isSupraUi, isVersatileUi } = useContext(BrandingContext);

  return (
    <div
      className="row align-items-center"
      style={{ marginLeft: '-14px' }}
      {...restrictedTooltip}
    >
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        className="switch position-relative d-inline-block"
        htmlFor={`toggle-switch-input-${children}`}
      >
        <input
          checked={checked}
          disabled={disabled}
          id={`toggle-switch-input-${children}`}
          onChange={onChange}
          type="checkbox"
        />
        <span className="slider position-absolute round" />
      </label>
      <p
        className={`mb-0 text-text-light-gray ${
          geofencesLoading ? 'mr-4' : ''
        }`}
      >
        {children}
      </p>
      {geofencesLoading ? (
        <FontAwesomeIcon
          color="var(--brand-primary)"
          icon={faCircleNotch}
          spin
        />
      ) : null}
      <ReactToolTip />
      <style jsx>{`
        /* The switch - the box around the slider */
        .switch {
          width: 34px;
          height: 20px;
          margin-left: 6%;
          margin-right: 6%;
          margin-top: 4px;
          margin-bottom: 4px;
        }

        /* Hide default HTML checkbox */
        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        /* The slider */
        .slider {
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: var(--light-gray-3);
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }

        .slider:before {
          position: absolute;
          content: '';
          height: 17px;
          width: 17px;
          left: 1px;
          bottom: 1px;
          background-color: white;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }

        input:checked + .slider {
          background-color: var(
            --${isVersatileUi || isSupraUi ? 'brand-primary' : 'highlight-blue'}
          );
        }

        input:focus + .slider {
          box-shadow: 0 0 1px #2196f3;
        }

        input:checked + .slider:before {
          -webkit-transform: translateX(15px);
          -ms-transform: translateX(15px);
          transform: translateX(15px);
        }

        /* Rounded sliders */
        .slider.round {
          border-radius: 34px;
        }

        .slider.round:before {
          border-radius: 50%;
        }
      `}</style>
    </div>
  );
}

ToggleSwitch.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.oneOf([
    'Suborg Assets',
    'Active Alarms',
    'Offline Assets',
    'Geofences',
  ]),
  disabled: PropTypes.bool,
  geofencesLoading: PropTypes.bool,
  onChange: PropTypes.func,
};
